import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { ChevronDown, Menu, X, Phone } from "lucide-react";
import { CATEGORIES, img, useSettings } from "../../lib/api";

export const Logo = ({ light = false }) => {
  const { data: s } = useSettings();
  const icon = s?.logo_url || "/api/uploads/logo-sapi.png";
  return (
    <Link to="/" className="flex items-center gap-3" data-testid="site-logo">
      <span className={`grid h-14 w-14 shrink-0 place-items-center ${light ? "rounded-full bg-white p-1.5" : ""}`}>
        <img src={img(icon)} alt="Logo Sembada Satwa" className="h-full w-full object-contain" data-testid="site-logo-image" />
      </span>
      <span className="flex flex-col">
        <span className={`font-display text-xl font-semibold leading-tight ${light ? "text-white" : "text-[var(--leaf)]"}`}>
          Sembada <span className={light ? "text-[var(--gold)]" : "text-[var(--forest)]"}>Satwa</span>
        </span>
        <span className={`text-[10px] leading-snug sm:text-xs ${light ? "text-white/70" : "text-[var(--earth)]"}`} data-testid="site-logo-tagline">
          Peternakan Cerdas untuk Sapi yang Lebih Sehat
        </span>
      </span>
    </Link>
  );
};

const linkCls = ({ isActive }) =>
  `text-sm font-medium transition-colors ${isActive ? "text-[var(--forest)]" : "text-[var(--ink)]/70 hover:text-[var(--forest)]"}`;

const EduDropdown = () => (
  <div className="group relative" data-testid="nav-edukasi-dropdown">
    <NavLink to="/edukasi" className={(s) => `${linkCls(s)} inline-flex items-center gap-1 py-6`} data-testid="nav-edukasi">
      Pojok Edukasi <ChevronDown className="h-4 w-4 transition-transform group-hover:rotate-180" />
    </NavLink>
    <div className="invisible absolute left-1/2 top-full w-56 -translate-x-1/2 translate-y-2 rounded-2xl border bg-white p-2 opacity-0 shadow-xl transition-[opacity,transform] group-hover:visible group-hover:translate-y-0 group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100">
      {CATEGORIES.map((c) => (
        <Link key={c.slug} to={`/edukasi?kategori=${c.slug}`} className="block rounded-xl px-4 py-2.5 text-sm text-[var(--ink)]/80 hover:bg-[var(--cream)] hover:text-[var(--forest)]" data-testid={`nav-edukasi-${c.slug}`}>
          {c.label}
        </Link>
      ))}
    </div>
  </div>
);

const MobileMenu = ({ onClose }) => (
  <div className="border-t bg-white px-5 pb-6 pt-2 lg:hidden" data-testid="mobile-menu">
    {[["/", "Beranda"], ["/katalog", "Katalog Sapi"], ["/edukasi", "Pojok Edukasi"]].map(([to, label]) => (
      <Link key={to} to={to} onClick={onClose} className="block border-b py-3 font-medium text-[var(--ink)]">{label}</Link>
    ))}
    <div className="border-b py-2 pl-4">
      {CATEGORIES.map((c) => (
        <Link key={c.slug} to={`/edukasi?kategori=${c.slug}`} onClick={onClose} className="block py-2 text-sm text-[var(--ink)]/70" data-testid={`mobile-nav-${c.slug}`}>
          {c.label}
        </Link>
      ))}
    </div>
    <Link to="/kontak" onClick={onClose} className="btn-gold mt-4 w-full" data-testid="mobile-cta-contact">
      <Phone className="h-4 w-4" /> Hubungi Kami
    </Link>
  </div>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  return (
    <header className="sticky top-0 z-40 border-b border-black/5 bg-white/90 backdrop-blur-lg" data-testid="site-header">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 lg:px-8">
        <Logo />
        <nav className="hidden items-center gap-9 lg:flex">
          <NavLink to="/" end className={linkCls} data-testid="nav-home">Beranda</NavLink>
          <NavLink to="/katalog" className={linkCls} data-testid="nav-katalog">Katalog Sapi</NavLink>
          <EduDropdown key={pathname} />
        </nav>
        <Link to="/kontak" className="btn-gold hidden lg:inline-flex" data-testid="header-cta-contact">
          <Phone className="h-4 w-4" /> Hubungi Kami
        </Link>
        <button className="rounded-full p-2 lg:hidden" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && <MobileMenu onClose={() => setOpen(false)} />}
    </header>
  );
};
